var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("main", { staticClass: "main", attrs: { role: "main" } }, [
        _c(
          "nav",
          {
            staticClass:
              "navbar navbar-lg navbar-expand-lg navbar-transparant navbar-absolute w-100 justify-content-end"
          },
          [
            _c("div", { staticClass: "dropdown" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary dropdown-toggle mr-2",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("navbar.language")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.changeLanguage("en")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("languageChoice.English")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.changeLanguage("zh")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("languageChoice.Chinese")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.changeLanguage("jp")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("languageChoice.Japanese")) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container pt-6" }, [
          _c("div", { staticClass: "row align-items-center entire-screen" }, [
            _c(
              "div",
              { staticClass: "col-sm-10 col-md-8 col-lg-6 mx-auto my-4" },
              [
                _c("div", { staticClass: "text-center" }, [
                  _c("h1", { staticClass: "h3" }, [
                    _vm._v(_vm._s(_vm.$t("login.welcome")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("login.explain")) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "m-sm-4" }, [
                      _c(
                        "form",
                        {
                          staticClass: "demo-ruleForm pt-4 needs-validation",
                          attrs: { "label-width": "0px", novalidate: "" }
                        },
                        [
                          _c("p", {
                            staticClass: "text-center",
                            staticStyle: { color: "red" },
                            domProps: { innerHTML: _vm._s(_vm.message) }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "email" } }, [
                              _vm._v(_vm._s(_vm.$t("login.email")))
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                }
                              ],
                              staticClass: "form-control form-control-lg",
                              attrs: {
                                type: "email",
                                id: "email",
                                placeholder: _vm.$t("login.emailPlaceholder"),
                                required: ""
                              },
                              domProps: { value: _vm.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("login.emailRequired")) +
                                  "\n                    "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "password" } }, [
                              _vm._v(_vm._s(_vm.$t("login.password")))
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                }
                              ],
                              ref: "password",
                              staticClass: "form-control form-control-lg",
                              attrs: {
                                type: "password",
                                id: "password",
                                placeholder: _vm.$t(
                                  "login.passwordPlaceholder"
                                ),
                                required: ""
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("login.passwordRequired")) +
                                  "\n                    "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("small", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "javascript:void(0);",
                                  "data-toggle": "modal",
                                  "data-target": "#forgetPasswordModal"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("forgotPassword.forgotPasswordText")
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-center mt-5" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-lg btn-primary",
                                attrs: { type: "submit" },
                                on: { click: _vm.login }
                              },
                              [_vm._v(_vm._s(_vm.$t("login.login")))]
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("copyright"),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "demo-ruleForm needs-validation-verified-step2",
          attrs: { "label-width": "0px", novalidate: "" }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "authenticatorModalVerifiedStep2",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "authenticatorModalVerifiedStep2",
                "aria-hidden": "true"
              }
            },
            [
              _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h4",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "authenticatorModalLabel" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("TwiceVerification.twiceVerification")
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body pt-5 pb-7" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "TwiceVerification.verificationCodeExplainLogin"
                            )
                          )
                        )
                      ]),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "verificationCodeStep2" } }, [
                        _c("h5", [
                          _vm._v(
                            _vm._s(_vm.$t("TwiceVerification.verificationCode"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.verificationCode,
                            expression: "verificationCode"
                          }
                        ],
                        staticClass: "form-control form-control-lg mt-2",
                        attrs: { id: "verificationCodeStep2", required: "" },
                        domProps: { value: _vm.verificationCode },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.verificationCode = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "TwiceVerification.verificationCodeRequired"
                              )
                            ) +
                            "\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer pt-5 pb-3" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-outline-secondary",
                          attrs: { type: "button", "data-dismiss": "modal" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("modal.modalCancel")) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-primary",
                          attrs: { type: "submit" },
                          on: { click: _vm.verifiedStep2 }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("TwiceVerification.modalSubmit"))
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "demo-ruleForm needs-validation-verified-step1",
          attrs: { "label-width": "0px", novalidate: "" }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "authenticatorModalVerifiedStep1",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "authenticatorModalVerifiedStep1",
                "aria-hidden": "true"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c(
                        "h4",
                        {
                          staticClass: "modal-title",
                          attrs: { id: "authenticatorModalLabel" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("TwiceVerification.bindAuthenticator")
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c("h5", [
                        _vm._v(
                          "1." +
                            _vm._s(
                              _vm.$t(
                                "TwiceVerification.SetVerificationCodeStep1"
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("h5", [
                        _vm._v(
                          "2." +
                            _vm._s(
                              _vm.$t(
                                "TwiceVerification.SetVerificationCodeStep2"
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "qrcode" }, [
                        _c("img", { attrs: { src: _vm.qrcodeURL } })
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("TwiceVerification.UrlCopy")) +
                            "\n              "
                        ),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "javascript:void(0);",
                              title: _vm.$t("TwiceVerification.Copy")
                            },
                            on: { click: _vm.copySecret }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-clone",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "form-control ml-3",
                        staticStyle: { width: "auto" },
                        attrs: { id: "inputCom", readonly: "" },
                        domProps: { value: _vm.secret }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-3 pb-3" }, [
                        _c("h5", [
                          _vm._v(
                            "3." +
                              _vm._s(
                                _vm.$t(
                                  "TwiceVerification.SetVerificationCodeStep3"
                                )
                              )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("h5", { staticClass: "col-8 col-md-6" }, [
                        _vm._v(
                          _vm._s(_vm.$t("TwiceVerification.verificationCode"))
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.verificationCode,
                              expression: "verificationCode"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { required: "", id: "verificationCodeStep1" },
                          domProps: { value: _vm.verificationCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.verificationCode = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "TwiceVerification.verificationCodeRequired"
                                )
                              ) +
                              "\n              "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer pt-5 pb-5" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-outline-secondary",
                            attrs: { type: "button", "data-dismiss": "modal" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("modal.modalCancel")) +
                                "\n              "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-primary",
                            attrs: { type: "submit" },
                            on: { click: _vm.verifiedStep1 }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("TwiceVerification.modalSubmit"))
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "demo-ruleForm needs-validation-forget-password",
          attrs: { "label-width": "0px", novalidate: "" }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "forgetPasswordModal",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "forgetPasswordModal",
                "aria-hidden": "true"
              }
            },
            [
              _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h4",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "forgetPasswordModalLabel" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("forgotPassword.modalTitle")) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "forgetEmail" } }, [
                        _vm._v(_vm._s(_vm.$t("login.email")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.forgetPasswordEmail,
                            expression: "forgetPasswordEmail"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        attrs: {
                          type: "email",
                          id: "forgetEmail",
                          required: ""
                        },
                        domProps: { value: _vm.forgetPasswordEmail },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.forgetPasswordEmail = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("login.emailRequired")) +
                            "\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer pt-5 pb-5" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-outline-secondary",
                          attrs: { type: "button", "data-dismiss": "modal" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("modal.modalCancel")) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-primary",
                          attrs: { type: "submit" },
                          on: { click: _vm.forgetPassword }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("TwiceVerification.modalSubmit"))
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a8c91a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a8c91a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/operator/login.vue
// module id = null
// module chunks = 